import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useMediaQuery } from "react-responsive";

const CertificationsCard = (props) => {
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1000px)" });
  const [name, setName] = useState(props.name);
  const [certificationThumbnail, setCertificationThumbnail] = useState(
    props.certificationThumbnail
  );
  const [certificationDescription, setCertificationDescription] = useState(
    props.certificationDescription
  );
  const [certificationUrl, setCertificationUrl] = useState(
    props.certificationUrl
  );

  useEffect(() => {
    setName(props.name);
    setCertificationThumbnail(props.certificationThumbnail);
    setCertificationDescription(props.certificationDescription);
    setCertificationUrl(props.certificationUrl);
  }, []);

  const viewClickHandler = (certUrl) => {
    window.open(certUrl);
  };

  return (
    <Card
      style={{
        border: "1px solid #E0E0E0",
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "column",
        width: isTabletOrMobile ? "100%" : "300px",
        marginTop: "20px",
        boxShadow: "8px 5px 15px #E0E0E0",
        borderRadius: "12px",
      }}
    >
      <div>
        <CardMedia
          component="img"
          height="150px"
          image={certificationThumbnail}
          alt="certification image"
        />
        <CardContent>
          <Typography
            style={{
              textAlign: "center",
              fontFamily: "Tenorite",
              fontWeight: "600",
            }}
            gutterBottom
            variant="h5"
            component="div"
          >
            {name}
          </Typography>
          <Typography
            style={{
              textAlign: "center",
              fontFamily: "Tenorite",
              fontSize: "15px",
            }}
            variant="body2"
            color="text.secondary"
          >
            {certificationDescription}
          </Typography>
        </CardContent>
      </div>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <CardActions>
          <Button
            disabled
            style={{ fontFamily: "Tenorite" }}
            size="small"
            variant="outlined"
            onClick={() => viewClickHandler(certificationUrl)}
          >
            VIEW CERTIFICATE
          </Button>
        </CardActions>
      </div>
    </Card>
  );
};

export default CertificationsCard;
